var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagnifySearchField = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.27 19.21",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "magnifySearchField")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Top_Bar",
  "data-name": "Top Bar"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.61,15.32A7.66,7.66,0,0,1,3.94,7.66,7.67,7.67,0,1,1,17,13.08,7.6,7.6,0,0,1,11.61,15.32Zm0-13.23a5.57,5.57,0,1,0,3.94,1.63A5.58,5.58,0,0,0,11.61,2.09Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  x: -0.52,
  y: 14.35,
  width: 8.71,
  height: 2.1,
  transform: "translate(-9.72 7.14) rotate(-44.66)",
  fill: "currentColor"
})))));
export default SvgMagnifySearchField;